// extracted by mini-css-extract-plugin
module.exports = {"option":"LineWidthSelector_option__3cPJq","line":"LineWidthSelector_line__26pse"};